import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { ArrowsPointingOutIcon, ArrowsPointingInIcon } from '@heroicons/react/24/solid';

const ParallelNode: React.FC<NodeProps> = ({ data, selected }) => {
  const isJoin = data.label?.includes('Join') || data.type === 'PARALLEL_JOIN';
  const Icon = isJoin ? ArrowsPointingInIcon : ArrowsPointingOutIcon;

  return (
    <div
      className={`px-1 py-0.5 shadow-sm rounded bg-white border ${
        selected ? 'border-primary-500' : 'border-purple-500'
      }`}
    >
      <div className="flex items-center">
        <div className="rounded-full w-4 h-4 flex items-center justify-center bg-purple-100">
          <Icon className="w-3 h-3 text-purple-600" />
        </div>
        <div className="ml-1">
          <div className="text-[10px] font-semibold text-gray-700">{data.label}</div>
        </div>
      </div>

      {isJoin ? (
        <>
          <Handle
            type="target"
            position={Position.Left}
            id="input1"
            className="w-3 h-3 bg-purple-500 border-2 border-white hover:w-4 hover:h-4 transition-all cursor-crosshair"
            style={{ top: '30%', left: '-6px' }}
            title="Input 1"
          />
          <Handle
            type="target"
            position={Position.Left}
            id="input2"
            className="w-3 h-3 bg-purple-500 border-2 border-white hover:w-4 hover:h-4 transition-all cursor-crosshair"
            style={{ top: '70%', left: '-6px' }}
            title="Input 2"
          />
          <Handle
            type="source"
            position={Position.Right}
            className="w-3 h-3 bg-purple-500 border-2 border-white hover:w-4 hover:h-4 transition-all cursor-crosshair"
            style={{ right: '-6px' }}
            title="Output"
          />
        </>
      ) : (
        <>
          <Handle
            type="target"
            position={Position.Left}
            className="w-3 h-3 bg-purple-500 border-2 border-white hover:w-4 hover:h-4 transition-all cursor-crosshair"
            style={{ left: '-6px' }}
            title="Input"
          />
          <Handle
            type="source"
            position={Position.Right}
            id="output1"
            className="w-3 h-3 bg-purple-500 border-2 border-white hover:w-4 hover:h-4 transition-all cursor-crosshair"
            style={{ top: '30%', right: '-6px' }}
            title="Output 1"
          />
          <Handle
            type="source"
            position={Position.Right}
            id="output2"
            className="w-3 h-3 bg-purple-500 border-2 border-white hover:w-4 hover:h-4 transition-all cursor-crosshair"
            style={{ top: '70%', right: '-6px' }}
            title="Output 2"
          />
        </>
      )}
    </div>
  );
};

export default ParallelNode;